(function () {
    'use strict';

    var $           = require('jquery');
    var $products   = $('.product-slider');
    var selected    = 'selected';

    function getGridSize() {
        return  (window.innerWidth < 600) ? 1 :
                (window.innerWidth < 900) ? 3 : 4;
    }

    if ($products.length > 0) {

        var flexslider = { vars:{} };

        $products.flexslider({
            slideshow:  false,
            animation:  'slide',
            controlNav: false,
            prevText:   $products.data('prev-text'),
            nextText:   $products.data('next-text'),
            minItems:   getGridSize(),
            maxItems:   getGridSize(),
            itemWidth:  295,
            itemMargin: 20,
            start: function (slider) {

                //  Replace the prev/next buttons with custom arrows
                slider.find('.flex-prev, .flex-next').html('<span class="icon"><svg><use xlink:href="' + slider.data('svg-url') + '#chevron"></use></svg></span>');

            }
        });

        $(window).on('resize', function () {

            var gridSize = getGridSize();

            flexslider.vars.minItems = gridSize;
            flexslider.vars.maxItems = gridSize;

        });

    }

})();